import { Backdrop, CircularProgress, Dialog, DialogContent, DialogContentText, Grid } from '@mui/material'
import React from 'react'

const LoadDialog = ({message,load}) => {
  return (
    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={load}>
    <Dialog
    open={load}
    aria-labelledby="map-loading-dialog"
    >
      <DialogContent>
        <Grid container={true} spacing={2} alignItems="center">
          <Grid item={true}>
      <CircularProgress color="primary" />
      </Grid>
      <Grid item={true}>
        <DialogContentText id="map-loading-text">
          {message}
        </DialogContentText>
        </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
    </Backdrop>
  )
}

export default LoadDialog